import { type PropsWithChildren, useEffect } from "react";

import { useConfig } from "@jti/app-context/useConfig";
import { hasOngoingSubscriptionError } from "@jti/commerce/shared";

import { useCartItems } from "@checkout-v2/shared/hooks/useCartItems";

type CheckoutGuardProps = PropsWithChildren<{
  onNavigate?: (url: string) => void;
}>;

export const CheckoutGuard = ({ children, onNavigate }: CheckoutGuardProps) => {
  const { CART_CHECKOUT_PAGE_URL } = useConfig();
  const { data: cartItems, isLoading } = useCartItems();

  const shouldRedirect = !isLoading && hasOngoingSubscriptionError(cartItems);

  useEffect(() => {
    if (!shouldRedirect) {
      return;
    }

    if (onNavigate) {
      onNavigate(CART_CHECKOUT_PAGE_URL);
      return;
    }

    window.location.replace(CART_CHECKOUT_PAGE_URL);
  }, [shouldRedirect, CART_CHECKOUT_PAGE_URL, onNavigate]);

  return shouldRedirect ? null : children;
};
